export default __webpack_public_path__ + "static/media/changjiang.ee2c2e12.png";